import React, { useEffect, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Flex, Heading } from '@front/gatsby-ui';

import { api, statsDefault } from '@front/gatsby-utils/api';

import useOnScreen from '@front/hooks/useOnScreen';
import useApi from '@front/hooks/useApi';
import Item from './item';

const Stats = ({ defaultData, ...rest }) => {
  const ref = useRef({ current: null });
  const isIntersecting = useOnScreen(ref, { init: false, once: true });
  const {
    request,
    /**
     * @type {Statistics}
     */
    data = defaultData,
  } = useApi(api.stats, {}, false);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (isIntersecting) {
      request();
    }
  }, [isIntersecting]);
  /* eslint-enable react-hooks/exhaustive-deps */

  const items = Object.keys(data).map(key => (
    <Item
      key={key}
      name={key}
      value={data[key]}
    />
  ));

  return (
    <Fragment>
      <Heading
        as="h2"
        variant="h2"
        textAlign="center"
      >
        In IT we trust the numbers
      </Heading>

      <Flex
        ref={ref}
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        py={4}
        {...rest}
      >
        {items}
      </Flex>
    </Fragment>
  );
};

Stats.propTypes = {
  defaultData: PropTypes.shape({
    orders_count: PropTypes.number.isRequired,
    quality_score: PropTypes.number.isRequired,
    writers_count: PropTypes.number.isRequired,
    writers_online: PropTypes.number.isRequired,
  }),
};

Stats.defaultProps = {
  defaultData: statsDefault,
};

export default Stats;
